import ConfigurationContainer from "./configurationContainer";

export default ConfigurationContainer;
